var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectionsSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ec1946",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.49,45.83a1,1,0,0,0,1.366-.366l4-6.928a1,1,0,0,0-.366-1.366l-2.6-1.5a12.352,12.352,0,0,0,0-3.334l2.6-1.5a1,1,0,0,0,.366-1.366l-4-6.928a1,1,0,0,0-1.366-.366l-2.6,1.5a12.9,12.9,0,0,0-2.445-1.446l-.315-6.6a4.9,4.9,0,0,0,3.747,0l-.158,3.324A1,1,0,0,0,44.666,20h.049a1,1,0,0,0,1-.952l.24-5.021A4.954,4.954,0,0,0,47,11c0-1.346-.834-2.46-1.718-3.64A12.058,12.058,0,0,1,42.968,3.1,1.291,1.291,0,0,0,41.54,2.011C39.6,2.26,37,9.251,37,11a4.954,4.954,0,0,0,1.047,3.027L38.237,18H35a1,1,0,0,0,0,2h3v2.7a1,1,0,0,0,.666.943,10.946,10.946,0,0,1,3.475,2,1,1,0,0,0,1.15.107L45.624,24.4l3,5.2-2.333,1.347a1,1,0,0,0-.483,1.048,10.586,10.586,0,0,1,0,4.014,1,1,0,0,0,.483,1.048L48.624,38.4l-3,5.2L43.291,42.25a1,1,0,0,0-1.15.107,10.946,10.946,0,0,1-3.475,2A1,1,0,0,0,38,45.3V48H32V45.3a1,1,0,0,0-.666-.943,10.946,10.946,0,0,1-3.475-2,1,1,0,0,0-1.15-.107L24.376,43.6l-1.211-2.1a1,1,0,0,0-1.732,1l1.711,2.964a1,1,0,0,0,1.366.366l2.6-1.5A12.915,12.915,0,0,0,30,45.989V49a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V45.989a12.915,12.915,0,0,0,2.886-1.663ZM41.4,4.735a15.742,15.742,0,0,0,2.284,3.824A5.047,5.047,0,0,1,45,11a3,3,0,0,1-6,0C39,9.769,40.421,6.353,41.4,4.735Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,38a1,1,0,0,0,0,2,6,6,0,0,0,0-12,1,1,0,0,0,0,2,4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.374,54.615l-4-7.194A3.016,3.016,0,0,1,57,45.963V40a3,3,0,0,0,0-6H51a1,1,0,0,0,0,2h6a1,1,0,0,1,0,2H53.434a1,1,0,0,0,0,2H55v4.574a1.493,1.493,0,0,1-2.033-.022,3.49,3.49,0,0,0-3.036-.97,1,1,0,1,0,.33,1.973,1.487,1.487,0,0,1,1.292.412,3.385,3.385,0,0,0,3.525.826,5.019,5.019,0,0,0,.551,1.6l4,7.2A2.97,2.97,0,0,1,57.029,60H46.971a2.971,2.971,0,0,1-2.6-4.414l4-7.194a1,1,0,0,0-1.748-.972l-4,7.194A4.971,4.971,0,0,0,46.971,62H57.029a4.97,4.97,0,0,0,4.345-7.385Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,39H31a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3V22a1,1,0,0,0,2,0V4H30V37H4V26a1,1,0,0,0-2,0V38A1,1,0,0,0,3,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,7a1,1,0,0,0-1-1H7A1,1,0,0,0,6,7v4a1,1,0,0,0,1,1H27a1,1,0,0,0,1-1Zm-2,3H8V8H26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,19a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V15a1,1,0,0,0-1-1H7a1,1,0,0,0-1,1Zm2-3h2v2H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,22H23a1,1,0,0,0-1,1V35a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23A1,1,0,0,0,27,22ZM26,34H24V24h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23a1,1,0,0,0-1-1H7a1,1,0,0,0-1,1Zm2-3h2v2H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,16a1,1,0,0,0,0-2H15a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,0-2H16V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,23a1,1,0,0,0-1-1H15a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1Zm-2,3H16V24h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,35a1,1,0,0,0,1,1h4a1,1,0,0,0,0-2H8V32h3a1,1,0,0,0,0-2H7a1,1,0,0,0-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,30H15a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V31A1,1,0,0,0,19,30Zm-1,4H16V32h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,15a1,1,0,0,0-1-1H23a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1Zm-2,3H24V16h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,11a4.972,4.972,0,0,1-.734,2.605,4.216,4.216,0,0,0-.365,3.678,3.852,3.852,0,0,0,2.5,2.335,9.005,9.005,0,0,0,9.311-2.624,9,9,0,0,0-9.339-14.6A3.833,3.833,0,0,0,47.9,4.717a4.222,4.222,0,0,0,.368,3.676A4.976,4.976,0,0,1,49,11Zm.769-5.575A1.822,1.822,0,0,1,50.96,4.3,6.944,6.944,0,0,1,53,4a7.359,7.359,0,0,1,.989.067,7.035,7.035,0,0,1,5.968,6.113A7,7,0,0,1,50.981,17.7a1.841,1.841,0,0,1-1.21-1.132,2.2,2.2,0,0,1,.2-1.92,6.993,6.993,0,0,0,0-7.306A2.2,2.2,0,0,1,49.769,5.425Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,44H3a1,1,0,0,0-1,1v6a1,1,0,0,0,2,0V46H8.586l6.15,6.15a1,1,0,0,0,1.414-1.414L11.414,46H18V56H4V55a1,1,0,0,0-2,0v2a1,1,0,0,0,1,1H6.382l-1,2H4a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2H16.618l-1-2H19a1,1,0,0,0,1-1V45A1,1,0,0,0,19,44ZM14.382,60H7.618l1-2h4.764Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,52H24a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V54A2,2,0,0,0,28,52Zm-4,8V54h4v6Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsSelected);
export default __webpack_public_path__ + "static/media/directions-selected.f4e2965a17375201ad49c51434f0f0db.svg";
export { ForwardRef as ReactComponent };